module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Ga-Hb-Ia 后背.916c4b1a.png";